/* Opciones de Edición */

//*react- recursos
  import React, { useState, useEffect } from "react";
  import swal2 from "sweetalert2"; //npm install --save sweetalert2

//*componentes-utiles
  import CargandoSpin from "../../../../componentes/CargandoSpin";

//*clases 
  import ReactTooltip from "react-tooltip";
  import '../../../../css/mdi.css'; 
  import { setRef } from "@mui/material";

//*archivos y componentes
  import VentanaLDAP from "./Configuracion.Panel.Editar.LDAP"; //ventana LDAP  

//*datos
  import etiquetasSSC from "../../../../datos/json/etiquetasSSC.json";
  
//*api's (servicios y store)
  import configurationsServicio from "../../../../api/recursos/configurations/configurations.servicio"; 
  import configurationsStore from "../../../../api/recursos/configurations/configurations.store"; 

 /*  import usersServicio from "../../../../api/recursos/users/users.servicio"; 
  import usersStore from "../../../../api/recursos/users/users.store";  */
 

//*store's

//*interfaces
  interface propsEditarUP {
    tokenStore:any,
    idPanel:any,
    upId:any,
    upAcronimo:any,
    upProceso:any,
    upCatPermisos:any,
    upCatPermisosOrigen:any,
    upUsuariosEspecificos:any,
    upSwUsuariosEspecificos:any,
    upMisUsuEspecificosOrigen:any,
    botonCierraSlidingPanel:any,
    recargaConfiguracionPanel:any,
    recargaPaginaSSC:any,
    recargaPaginaSSC_Not:any,
  }

//*componente
  export default function EditarUP(props: propsEditarUP) {
    var _ = require('underscore');
  
    //*api store
        const { cambiaUsuariosProponentesStore, canceloUsuarioProponenteStore, 
                guardaUpdateProponentUserStore, 
                generaObjErrorConfigurationsStore} =  
            configurationsStore((state:any) =>( { 
                cambiaUsuariosProponentesStore: state.cambiaUsuariosProponentesStore,
                canceloUsuarioProponenteStore: state.canceloUsuarioProponenteStore,
                guardaUpdateProponentUserStore: state.guardaUpdateProponentUserStore,
                generaObjErrorConfigurationsStore: state.generaObjErrorConfigurationsStore,
        }));

       /*  const { guardaSearchUserLDAPStore, usuariosLDAPStore,
                generaObjErrorUsersStore} =  
            usersStore((state:any) =>( { 
                guardaSearchUserLDAPStore: state.guardaSearchUserLDAPStore,
                usuariosLDAPStore: state.usuariosLDAPStore,
                generaObjErrorUsersStore: state.generaObjErrorUsersStore,
        })); */

    //*store's

    //*datos
      let bodyAPIGuardar:any =  { id:null,  sync: true,  setting: { right_propose: 0, specificuser: [] } }
    
    //*constantes y variables
      let etiRP = etiquetasSSC.RP;
      let etiGlobal = etiquetasSSC.Global;
      let x0:any, x1:any, x2:any, x3:any, x4:any, x5:any, x6:any, x7:any , x8:any  = '';
      let msjError = "<div class='font-size-14'><p>" + "Tiene activo <b>Usuarios específicos</b> y no los ha agregado <br /> " + "<p><p class='text-center'> "+ "¿Desea agregar?" + "</p></div>";

    //*useState
      const [swRecarga, setSwRecarga] = useState(false); //usado para remasterizar
      const [swRecargaConfiguracionPanelEditarUP, setSwRecargaConfiguracionPanelEditarUP] = useState(false); //usado para remasterizar esta página
      const [cargandoSpin, setCargandoSpin] = useState(false);

      //upUsuariosEspecificos = {upUsuariosEspecificos}
      const [upSwUsuariosEspecificosOrigen, setUpSwUsuariosEspecificosOrigen] = useState(props.upSwUsuariosEspecificos);
      const [upMisUsuEspecificosOrigen, setUpMisUsuEspecificosOrigen] = useState(props.upMisUsuEspecificosOrigen);

      const [upUsuariosEspecificosFront, setUpUsuariosEspecificosFront] = useState(props.upUsuariosEspecificos);
      
      const [swUsuarioEspecifico, setSwUsuarioEspecifico] = useState(props.upSwUsuariosEspecificos);
      const [swBotonGuardarFront, setSwBotonGuardarFront] = useState(false);
      const [swBotonBuscarFront, setSwBotonBuscarFront] = useState(false);
      const [swBotonAgregarFront, setSwBotonAgregarFront] = useState(false);
      const [swActivaListaLDAP, setSwActivaListaLDAP] = useState(false);

      const [swMensaje, setSwMensaje] = useState(false);
      const [swContinuar, setSwContinuar] = useState(true); 

      const [valorInput, setValorInput] = useState("");
      const [usuariosSeleccionado, setUsuariosSeleccionado] = useState({ name: "", email: ""});
      const [upCatPermisosFront, setUpCatPermisosFront] = useState([]);
                  
      const [abreSP, setAbreSP] = useState(false);
    
    //*useEffect
      useEffect(()=> { // cargo
        console.log('Editar - monto');
        console.log('upSwUsuariosEspecificosOrigen...', upSwUsuariosEspecificosOrigen)
        console.log('upMisUsuEspecificosOrigen...', upMisUsuEspecificosOrigen)
        
        
        //if (props.upUsuariosEspecificos.length > 0) { setSwUsuarioEspecifico(true) }
        //if (props.upCatPermisos[5].activo = true ) { setSwUsuarioEspecifico(true) }
        //console.log('idPanel', props.idPanel);
        //console.log('upId', props.upId);
        //console.log('upAcronimo', props.upAcronimo );
        //console.log('upProceso', props.upProceso);
        //console.log('upCatPermiso', props.upCatPermisos);
        //console.log('upCatPermisosOrigen', props.upCatPermisosOrigen);
        //console.log('upUsuariosEspecificos', props.upUsuariosEspecificos);
        //console.log('***********swUsuarioEspecifico', swUsuarioEspecifico);

        ////setUpUsuariosEspecificosFront(JSON.parse(JSON.stringify(props.upUsuariosEspecificos)))
        setSwActivaListaLDAP(false);
       // setSwError(false);
        setSwContinuar(true);
        setSwRecarga(!swRecarga);

      },[]);
      
      useEffect(()=> { // uso este puente para recargar elementos del front
        console.log('Editar - rederizando............');
        setSwRecargaConfiguracionPanelEditarUP(!swRecargaConfiguracionPanelEditarUP);
        console.log('-- upCatPermiso', props.upCatPermisos);
        console.log('swUsuarioEspecifico', swUsuarioEspecifico);
        //console.log('-- upCatPermisosOrigen', props.upCatPermisosOrigen);
        //console.log('-- upUsuariosEspecificosFront....', upUsuariosEspecificosFront)
        //console.log('upUsuariosEspecificosFront....', upUsuariosEspecificosFront);
      },[swRecarga]);

    //*funciones
      const recargaPaginaSSC = () => { props.recargaPaginaSSC() } //ejecuta la función que esta en Contenido que llama a la renderización de PaginaSSC
      //const recargaPaginaSSC_Not = () => { props.recargaPaginaSSC_Not() } //ejecuta la función que esta en Contenido que llama de PaginaSSC recargar el api de notificaciones para la campana
      //const recargaConfiguracion = () => { props.recargaConfiguracion() }

      const recargaConfiguracionPanel = () => { props.recargaConfiguracionPanel() }

      const recargaConfiguracionPanelEditarUP = () => {
        //alert('recargaConfiguracionPanelEditarUP');
        //console.log('recargaConfiguracionPanelEditarUP....')
        setSwRecarga(!swRecarga); // con esto ejecuto un useEffect, lo uso para renderizar el front 
      }
    
      const cambiaCatPermisos = (e:any) => {
        //alert('cambiaCatPermisos - id: ' + e.target.id + '  .. value: '+ e.target.value );
        console.log('----e.target.id:', e.target.id, '..e.target.value: ', e);
        let idCat =  e.target.id
        let checkCat =  e.target.checked;
        if (idCat == 5) {
           setSwUsuarioEspecifico(!swUsuarioEspecifico);
           cambiaListaUsuarios('UP',[])
           //console.log('----swUsuarioEspecifico:', swUsuarioEspecifico)
        }
        if (idCat == 3 && checkCat) { setSwUsuarioEspecifico(false) }

        cambiaUsuariosProponentesStore(props.upId, idCat, null, 'cambiaCatPermisos');
        setSwBotonGuardarFront(true);
        recargaConfiguracionPanelEditarUP();
        recargaConfiguracionPanel();
      }

      const botonCerrar = () => {  
        if (swBotonGuardarFront) { //si esta activo el botón guardar hay cambios...
                swal2.fire({
                    text: "",
                    icon: 'question',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Si',
                    cancelButtonText: 'No',
                    width: '50%',
                    html: "<div>" + 'Se detectaron cambios sin guardar. ¿Está seguro de salir de la ventana Editar?'+ "</div>",
                }).then((result) => {
                    if (result.isConfirmed) {
                        //cambiaUsuariosProponentesStore(props.upId, upSwUsuariosEspecificosOrigen, props.upCatPermisosOrigen, 'botonCerrarSinCambios');
                        //canceloUsuarioProponenteStore: async ( id:any, swUsu:any, catPermisosOrigen:any, misUsuariosEspecificosOrigen:any )
                        canceloUsuarioProponenteStore(props.upId, upSwUsuariosEspecificosOrigen, props.upCatPermisosOrigen, props.upMisUsuEspecificosOrigen);
                        recargaConfiguracionPanelEditarUP();
                        recargaConfiguracionPanel();  //actualizamos páginas de atrás
                       
                        setSwUsuarioEspecifico(upSwUsuariosEspecificosOrigen);
                        recargaConfiguracionPanelEditarUP();
                        console.clear();
                        console.log('upSwUsuariosEspecificosOrigen...', upSwUsuariosEspecificosOrigen);
                        console.log('swUsuarioEspecifico...', swUsuarioEspecifico);
                        props.botonCierraSlidingPanel('');
                       
                        setSwRecarga(!swRecarga);
                    }
                    else
                        return;
                })
        }
        else {  //cerramos SlipingPanel desde RD
          recargaConfiguracionPanelEditarUP();
          recargaConfiguracionPanel();  //actualizamos páginas de atrás
          props.botonCierraSlidingPanel('');
        } 
      }

      const botonGuardar = () => {
        console.clear();
        console.log('swUsuarioEspecifico..', swUsuarioEspecifico , ' upUsuariosEspecificosFront ', upUsuariosEspecificosFront.length)
        if (swUsuarioEspecifico  && upUsuariosEspecificosFront.length == 0) {
            swal2.fire({
              title: "Tiene marcado la casilla de <b>Usuarios específicos</b>, agregue uno o más usuarios",
              icon: 'warning',
              confirmButtonColor: '#3085d6',
              confirmButtonText: "Cerrar",
              width: '60%',
            })
        }
        else { preguntaTodosProcesos() }
      }

      const preguntaTodosProcesos = () => {
        console.log('pregunto por todos los procesos'); 
        if (props.upId==0) { //selecciono el botón Editar de "Todos los programas a mi cargo"
            swal2.fire({
              title: "",
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Si',
              cancelButtonText: 'No',
              width: '50%',
              html: "<div class='font-size-14'><p>" + "Con esta acción los usuarios que tenga asignados a los procesos serán sustituidos por los indicados en esta sección." + "<br /><br />" +  "Las configuraciones anteriormente especificadas para cada proceso se eliminarán y serán reemplazadas por las aquí definidas." + "<p><p class='text-center'> "+ "¿Desea continuar?" + "</p></div>",
            }).then((result) => {
                if (result.isConfirmed) { guardaAPI() }
                else { return }
            })
        }
        else { guardaAPI() }
      }

      const guardaAPI = () => {
        //generamos body
          let bodyAPI = { id:null,  sync: true,  setting: { right_propose: 0, specificuser: [] } };
          bodyAPIGuardar = bodyAPI;
          bodyAPIGuardar.id= (props.upId == 0) ? null : props.upId;
          
          let paso = '';
          props.upCatPermisos?.map((catP:any, indexCatP:any) => {
            switch (catP.id) {
              case 0: if (catP.activo) { paso = paso + 'RPRD' }; break;
              case 3: if (catP.activo) { paso = paso + 'INEGI'}; break;
              case 4: if (catP.activo) { paso = paso + 'DG' }; break;
              case 5: if (catP.activo) { paso = paso + 'UE' }; break;
            }
          });
          switch (paso) {
            case 'RPRD':      bodyAPIGuardar.setting.right_propose = 3; break;
            case 'RPRDINEGI': bodyAPIGuardar.setting.right_propose = 7; break;
            case 'RPRDDG':    bodyAPIGuardar.setting.right_propose = 11; break;
            case 'RPRDUE':    
                  bodyAPIGuardar.setting.right_propose = 19; 
                  bodyAPIGuardar.setting.specificuser = upUsuariosEspecificosFront; 
                  break;
            case 'RPRDDGUE':  
                  bodyAPIGuardar.setting.right_propose = 27; 
                  bodyAPIGuardar.setting.specificuser = upUsuariosEspecificosFront; 
                  break;
          };
          if (swUsuarioEspecifico== false) { bodyAPIGuardar.setting.specificuser= [] };

          console.log(':::::::::::::::::::::::::::::::::::Antes de guardar-- bodyAPIGuardar::::::', bodyAPIGuardar);
        // llamando al api: Configurations/UpdateProponentUser
          setCargandoSpin(true);
          configurationsServicio.cargaUpdateProponentUser(props.tokenStore, bodyAPIGuardar)
            .then((response:any) => {
                if (response.status==200) {  //revisa si hay error
                    guardaUpdateProponentUserStore(response.data).then( function(updateProponentUserFront:any) { 
                        //console.log('actualizamos API: ', updateProponentUserFront );
                        setSwBotonGuardarFront(false);
                        swal2.fire({
                          title: 'La información para usuarios autorizados fue guardada', 
                          icon: 'success',
                          confirmButtonText: "Cerrar",
                          confirmButtonColor: '#3085d6',
                          width: "70%",
                        });
                        cambiaUsuariosProponentesStore(props.upId, null, upUsuariosEspecificosFront, 'botonGuardar');
                    });     
                }    
                setCargandoSpin(false);
            })
            .catch((ex) => {
                console.log ("--catch - ex (cargaInsertbyUser): ", ex.response.status);
                generaObjErrorConfigurationsStore(ex.response, true, '', '', 'Configuración.Panel.EditarUP/UpdateProponentUser','C');
                props.recargaPaginaSSC();
                setCargandoSpin(false);
            })
        recargaConfiguracionPanelEditarUP();
        recargaConfiguracionPanel();  //actualizamos páginas de atrás
      }

      const activaSwBotonGuardar = () => {
        setSwBotonGuardarFront(true);
      }

      const clicInputCheck = () => {
        setSwUsuarioEspecifico(!swUsuarioEspecifico)
        setSwBotonGuardarFront(true);
      }

      const cambiaListaUsuarios = (usuTipo:any, usuArreglo:any) => {
        //alert('cambiaListaUsuarios');
        console.log('EditarUP----cambiaListaUsuarios',usuTipo,usuArreglo );
        setUpUsuariosEspecificosFront(usuArreglo);
        cambiaUsuariosProponentesStore(props.upId, null, usuArreglo, 'cambiaListaUsuarios');
        console.log('upUsuariosEspecificosFront......',upUsuariosEspecificosFront ); 
        recargaConfiguracionPanelEditarUP();
        recargaConfiguracionPanel();
      } 

    //**vista 
      return (
      <>
        {/* subencabezado: acronimo & nombre del proceso */}
          <div>
              <p className='color-secundario h4'>{props.upAcronimo}</p>
              <p className={props.upId==0 ? 'color-secundario h4' : 'h5'}>{props.upProceso}</p>
              <hr />
          </div>

        {/* contenido - id=0 - Alta de usuarios proponentes */}
          <div id='SlidingPanel_contenido'>

            {/*Usuarios autorizados */}
              <p className='h5'>Usuarios autorizados</p> 
              
              <div className='margin-1r Font10'>  
                { props.upCatPermisos?.map((cpu:any, indexCPU:any) =>
                  (<>
                      {cpu.visible &&
                        (<>
                          <div className="divAnchoAvisos">
                            <input 
                              id={cpu.id} 
                              type="checkbox" 
                              checked={cpu.activo}
                              disabled={cpu.disabled}
                              onChange={cambiaCatPermisos}
                              /* onClick={()=>clicInputCheck()} */
                            />
                          </div>
                          <div style={{display:"inline-block"}}>{cpu.descripcion}</div><br/>
                        </>)
                      }
                    
                  </>)  
                )}  
              </div>  

            {/*Usuarios específicos */}
              {/*  <p>sw: {swUsuarioEspecifico ? <>t</> : <>f</>}   </p> */}
              {swUsuarioEspecifico &&  
                (<> <VentanaLDAP 
                          tokenStore = {props.tokenStore} 
                          id = {props.upId} 
                          usuTipo = {'UP'}
                          listaUsuarios = {upUsuariosEspecificosFront} 
                          cambiaListaUsuarios = {cambiaListaUsuarios}
                          activaSwBotonGuardar = {activaSwBotonGuardar}
                          recargaConfiguracionPanel = {recargaConfiguracionPanel}
                          recargaConfiguracionPanelEditar = {recargaConfiguracionPanelEditarUP}
                          recargaPaginaSSC = {props.recargaPaginaSSC} />
                </>) 
              }
              <br /> 
          </div>
              
         
        {/* Botones */}
          <hr />
          <div id="SlidingPanel_pie">
            <div className='text-right padding-botton-1r'>
                { swBotonGuardarFront  
                    ? (<> <button onClick={botonGuardar} className="btn btn-activo">  <span dangerouslySetInnerHTML={{ __html: etiGlobal.botones[2].text, }} ></span></button>&nbsp;</> )
                    : (<> <button className="btn btn-inactivo" disabled>  <span dangerouslySetInnerHTML={{ __html: etiGlobal.botones[2].text, }} ></span> </button>&nbsp;</>)
                }
                <button onClick={botonCerrar}  className="btn btn-sinColor"> <span dangerouslySetInnerHTML={{ __html: etiGlobal.botones[1].text, }} ></span> </button>&nbsp;
            </div>
          </div>

        {/* ventana de carga con spin que se abre mientras lee el api */}
          { cargandoSpin && <CargandoSpin />  }          
          
      </>
      );
  }
